import React, { useState, useEffect } from 'react';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';

const UpdateItemGridGRN = ({ onRequisitionData, itemData, grnData, selectedPOData, currencyPrecision }) => {
    
    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        qty: '',
        uom: '',
        vatDes: '',
        baseQty: '',
        baseAmount: '',
        amount: '',
        discount: '',
        vat: '',
        convValue: '',
        vatAmount: '',
        expDate: null,
        balQty: "",
        batchNo: "",
        inventoryAccountCode: "",
        inventoryAccountName: "",
    }]);
    useEffect(() => {
        const getItems = async () => {
            try {
                const apiService = new ApiService();
                let param = `?POrderNo=View?POrderNo=View&GRNNo=${grnData?.grnNo}&Mode=2`
                const PO = await apiService.getApiParamater("GET_PO_ITEM_UPDATE", param);

                const formattedRowsitm = itemData.map(async (detail, index) => {
                    const selecteditms = await apiService.getApiParamater("GET_ITEM", `?ItemNo=${detail.itemCode}`);
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                    const selectedGrnItem = PO.data.result?.find(rec => rec.itemDescription === detail.itemDescription)
                    let glAccount = getGLAccounts?.data?.result[0]
                    let itm = selecteditms?.data?.result[0]

                    return {
                        requisitionNo: detail.requisitionNo,
                        srno: detail?.srno,
                        ItemNo: detail.itemCode,
                        qty: detail.qty,
                        itemDescription: detail.itemDescription,
                        uom: detail.uom,
                        baseQty: itm.convToInvUOM * detail.qty,
                        baseAmount: detail.unitPrice?.toFixed(currencyPrecision || 3),
                        vat: detail.vatPerc,
                        vatDes: detail.vatDesc,
                        convValue: itm.convToInvUOM,
                        vatAmount: detail.vatAmount?.toFixed(currencyPrecision || 3),
                        freeQty: detail?.extraQty || 0,
                        specification: detail ? detail.specification : '',
                        amount: grnData?.eye === true ? detail.amount?.toFixed(currencyPrecision || 3) : detail.amount?.toFixed(currencyPrecision || 3),
                        balQty: selectedGrnItem?.balQty,
                        expDate: detail?.expDate,
                        batchNo: detail?.batchNo,
                        inventoryAccountCode: glAccount.inventoryAccountCode,
                        inventoryAccountName: glAccount.inventoryAccountName,
                        GRNAccountName: glAccount.grnAccountName,
                        GRNAccountCode: glAccount.grnAccountCode,
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsitm);
                if (formattedRows.length > 0) {
                    setRows(formattedRows);
                    onRequisitionData(formattedRows);
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };

        if (itemData) {
            getItems();
        }
    }, [itemData]);
    const handleQtyChange = (index, value) => {
        const newQty = value || '';
        const balQty = rows[index].balQty;
        const unitPrice = rows[index].baseAmount;
        const vatPerc = rows[index].vat;
        const vatInclusive = rows[index].vatInclusive;
        const UOM = rows[index].baseQty;
        const item = rows[index].itemDescription;
        const vatDes = rows[index].vatDes;
        if (newQty < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }
        if (newQty > balQty) {
            toast.warning('Enter a quantity less than or equal to the balance quantity.');
            return;
        }
        const amountBeforeVat = newQty * unitPrice;
        const vatAmount = (amountBeforeVat * vatPerc) / 100;
        let totalAmount;

        if (selectedPOData?.costCenter5 === "excluded") {
            totalAmount = amountBeforeVat + vatAmount;
        } else {
            totalAmount = amountBeforeVat;
        }
        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].qty = newQty;
            newRows[index].baseQty = newQty * UOM;
            newRows[index].amount = totalAmount;
            newRows[index].vatDes = vatDes;
            newRows[index].vatAmount = vatAmount;
            return newRows;
        });
        // }
    };
    const handleDateChange = (index, expDate) => {
        const updatedRows = [...rows];
        updatedRows[index].expDate = expDate;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, expDate: expDate } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    const handleFreeQTChange = (index, value) => {
        const newQty = value || 0;
        const balQty = rows[index].balQty;
        const qty = rows[index].qty || 0;

        if (newQty < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].freeQty = newQty;
            return newRows;
        });
    };

    const handleUnitPriceChange = (index, value) => {
        const unitPrice = value;
        const qty = rows[index].qty;
        const vatPerc = rows[index].vat;

        if (unitPrice < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }

        const amountBeforeVat = unitPrice * qty;
        const vatAmount = (amountBeforeVat * vatPerc) / 100;
        let totalAmount;

        if (selectedPOData?.costCenter5 === "excluded") {
            totalAmount = amountBeforeVat + vatAmount;
        } else {
            totalAmount = amountBeforeVat;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].baseAmount = unitPrice;
            newRows[index].amount = totalAmount;
            newRows[index].vatAmount = vatAmount;
            return newRows;
        });
    };

    const handleBatchNo = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].batchNo = value;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, batchNo: value } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const netAmount = rows?.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)
    const totalVat = rows?.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0)
    const totalDiscountAmount = rows?.reduce((sum, row) => sum + (parseFloat(row?.discountAmount) || 0), 0)
    const totalDiscount = rows?.reduce((sum, row) => sum + (parseFloat(row?.discount) || 0), 0)
    const calculatedTotal = rows?.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0)
    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "auto" }}>
                <table>
                    <thead className='dynoTable'>
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            <th>Bal Qty</th>
                            <th>Free Qty</th>
                            <th>Unit Price</th>
                            <th>Discount</th>
                            <th>VAT Desc</th>
                            <th>VAT %</th>
                            <th>VAT Amount</th>
                            <th>Amount</th>
                            <th>Batch No</th>
                            <th>Exp Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={index + 1} disabled style={{ width: "70px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.ItemNo} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "130px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'>
                                    {grnData?.eye === true ?
                                        <input
                                            className='p-2'
                                            type="number" onWheel={(e) => e.target.blur()}
                                            disabled style={{ width: "70px" }}
                                            value={row.qty}
                                        />
                                        :
                                        <input
                                            className='p-2' onWheel={(e) => e.target.blur()}
                                            type="number" style={{ width: "70px" }}
                                            value={row.qty}
                                            onKeyDown={preventNegativeSign}
                                            max={row.balQty}
                                            onChange={(e) => handleQtyChange(index, e.target.value)}
                                        />
                                    }
                                </td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "130px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.baseQty || 0} style={{ width: "130px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.balQty || 0} style={{ width: "80px" }} /></td>
                                <td className='m-0 p-0'>
                                    <input
                                        className='p-2' onWheel={(e) => e.target.blur()}
                                        type="number" style={{ width: "100px" }}
                                        value={row.freeQty}
                                        onKeyDown={preventNegativeSign}
                                        max={row.freeQty}
                                        onChange={(e) => handleFreeQTChange(index, e.target.value)}
                                    />
                                </td>
                                <td className='m-0 p-0'>
                                    <input
                                        className='p-2' onWheel={(e) => e.target.blur()}
                                        type="number" style={{ width: "100px" }}
                                        value={row.baseAmount} disabled
                                    />
                                </td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.discount} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.vatDes} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.vat + "%" || 0 + "%"} disabled style={{ width: "80px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.vatAmount || 0} disabled style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.amount || 0} style={{ width: "100px" }} /></td>
                                <input
                                    className='p-2' onWheel={(e) => e.target.blur()}
                                    type="number" style={{ width: "120px" }}
                                    value={row.batchNo}
                                    onKeyDown={preventNegativeSign}
                                    onChange={(e) => handleBatchNo(index, e.target.value)}
                                />
                                <td className='m-0 p-0'><input className='p-2' type='date' value={row?.expDate ? row.expDate.split('T')[0] : ''} disabled={grnData?.eye === true ? true : false}
                                    onChange={(e) => handleDateChange(index, e.target.value)} style={{ width: "130px" }} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='mt-3 p-1'>
                <div className='d-flex justify-content-between boxs  p-2 mt-5'>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Total Amount</div>
                        <div className='field'>{calculatedTotal?.toFixed(currencyPrecision || 3) || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Total Vat</div>
                        <div className='field'>{totalVat?.toFixed(currencyPrecision || 3) || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Net Amount</div>
                        <div className='field'>{netAmount?.toFixed(currencyPrecision || 3) || "---"}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateItemGridGRN;